import axios from 'axios';
import { getApiBaseUrl } from '@/utils/runtime'

// 创建axios实例
const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 添加认证信息，如token
    const token = localStorage.getItem('token');
    
    // 排除不需要token的接口：登录、验证码、忘记密码、重置密码
    const noTokenUrls = ['/auth/login'];
    const shouldAddToken = token && !noTokenUrls.some(url => config.url.includes(url));
    
    if (shouldAddToken) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  response => {
    if (response.config.responseType === 'blob') {
      return response
    }
    const data = response.data
    if (data && (data.code === 200 || data.code === '200')) {
      return data
    } else if (data && (data.code === 401 || data.code === '401' || data.code === 403 || data.code === '403')) {
      if (!response.config.suppressAuthRedirect) {
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        window.location.href = '#/login'
      }
      return Promise.reject(new Error(data.msg || data.message || '未授权'))
    } else {
      const error = new Error(data?.msg || data?.message || '请求失败')
      error.code = data?.code
      error.data = data
      return Promise.reject(error)
    }
  },
  error => {
    console.error('API请求错误:', error)
    
    if (error.response) {
      if ((error.response.status === 401 || error.response.status === 403) && !error.config?.suppressAuthRedirect) {
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        window.location.href = '#/login'
      }
      const responseData = error.response.data
      if (responseData?.msg || responseData?.message) {
        error.message = responseData.msg || responseData.message
      }
      return Promise.reject(error)
    }
    
    return Promise.reject(error)
  }
);

export default api;
